import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

const navItems = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/anomalies', label: 'Anomalies' },
  { to: '/reports', label: 'Reports' },
  { to: '/inventory-gaps', label: 'Inventory Gaps' },
  { to: '/settings', label: 'Settings' },
];

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, signOut } = useAuth();

  return (
    <div className="flex min-h-screen">
      <aside className="w-60 shrink-0 bg-slate-900 text-slate-200 flex flex-col">
        <div className="px-5 py-5 border-b border-slate-800">
          <div className="text-xs font-medium uppercase tracking-wider text-slate-400">Learning Pool</div>
          <div className="mt-1 text-base font-semibold text-white">Log Anomaly Platform</div>
        </div>
        <nav className="flex-1 p-3" aria-label="Primary">
          <ul className="space-y-1">
            {navItems.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    [
                      'block rounded-md px-3 py-2 text-sm transition-colors relative',
                      isActive
                        ? 'bg-slate-800 text-white font-medium'
                        : 'text-slate-300 hover:text-white hover:bg-slate-800/60',
                    ].join(' ')
                  }
                >
                  {({ isActive }) => (
                    <>
                      {isActive && (
                        <span className="absolute left-0 top-1.5 bottom-1.5 w-0.5 rounded bg-brand-500" aria-hidden />
                      )}
                      {item.label}
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
        {user && (
          <div className="border-t border-slate-800 p-4 text-xs">
            <div className="truncate text-slate-300">{user.email}</div>
            <button
              type="button"
              onClick={signOut}
              className="mt-2 text-slate-400 hover:text-white transition-colors"
            >
              Sign out
            </button>
          </div>
        )}
      </aside>
      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-7xl px-6 py-6 sm:px-8">{children}</div>
      </main>
    </div>
  );
};

export default Layout;
